export default {
  features: {
    updateClientQuestionnaire: {
      title: 'Личная информация',
      save: 'Сохранить',
    },
  },
};
